module.exports = __webpack_public_path__ + "static/media/blackCheck.9d5f9b17.svg";